"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateInputToDate = void 0;
var dateInputToDate = function (value) { return (typeof value === 'string' ? new Date(value) : value); };
exports.dateInputToDate = dateInputToDate;
//# sourceMappingURL=date.js.map